(function () {
  // Accordions: one open item per group, animated height that settles to auto.
  function hasTransition(panel) {
    return (parseFloat(window.getComputedStyle(panel).transitionDuration) || 0) > 0;
  }

  function openPanel(item) {
    var panel = item.querySelector('.cpdp-acc__panel');
    var trigger = item.querySelector('.cpdp-acc__trigger');
    panel.style.height = 'auto';
    var target = panel.scrollHeight;
    panel.style.height = '0px';
    panel.getBoundingClientRect();
    item.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    if (!hasTransition(panel)) {
      panel.style.height = 'auto';
      return;
    }
    panel.style.height = target + 'px';
    var done = function (event) {
      if (event.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', done);
      if (item.classList.contains('is-open')) panel.style.height = 'auto';
    };
    panel.addEventListener('transitionend', done);
  }

  function closePanel(item) {
    var panel = item.querySelector('.cpdp-acc__panel');
    var trigger = item.querySelector('.cpdp-acc__trigger');
    panel.style.height = panel.scrollHeight + 'px';
    panel.getBoundingClientRect();
    item.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    panel.style.height = '0px';
  }

  function initAccordions(scope) {
    scope.querySelectorAll('[data-cpdp-acc-group]').forEach(function (group) {
      if (group.dataset.cpdpAccReady) return;
      group.dataset.cpdpAccReady = 'true';
      group.addEventListener('click', function (event) {
        var trigger = event.target.closest('.cpdp-acc__trigger');
        if (!trigger || !group.contains(trigger)) return;
        var item = trigger.closest('.cpdp-acc__item');
        var wasOpen = item.classList.contains('is-open');
        group.querySelectorAll('.cpdp-acc__item.is-open').forEach(closePanel);
        if (!wasOpen) openPanel(item);
      });
    });
  }

  function initAll(scope) {
    initAccordions(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  window.CustomPdp = window.CustomPdp || {};
  window.CustomPdp.initAccordions = initAccordions;
})();